import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { DataService } from '../../../services/data.service';
import { AutocompleteService } from '../../../services/autocomplete.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { SieveString } from '../../../helpers/sieve/sieveString.class';
import { IShadowCustomerCreate } from '../../../models/request-and-responses/rest-api/interfaces/shadowCustomerCreate';
import { WithSearchBarAndSieve } from '../../../helpers/base-classes/withSearcBarAndSieve.class';
import { IShadowGenericAnagraphic } from '../../../models/request-and-responses/rest-api/interfaces/shadowGenericAnagraphic';
import { ModalMode } from '../../../helpers/modalMode.enum';
import { AnagraphicType } from '../../../models/request-and-responses/rest-api/enums/anagraphicType.enum';
import { City, ICity } from '../../../helpers/city.class';
import { ICityResponse } from '../../../models/request-and-responses/rest-api/interfaces/cityResponse';
import { LocalStorageService } from '../../../services/local-storage.service';
import { Subscription } from 'rxjs';
import { SieveFilter, SieveSort } from '../../../helpers/sieve/sieve-filters-and-sorts';
import { ShadowGenericAnagraphic } from '../../../models/request-and-responses/rest-api/classes/shadowGenericAnagraphic';
import { ShadowCustomerCreate } from '../../../models/request-and-responses/rest-api/classes/shadowCustomerCreate';
import { LocalStorageKey } from '../../../models/frontend/local-storage.key';
import { UserSessionInfo } from '../../../models/frontend/user.session-info';
import { SessionStorageService } from '../../../services/session-storage.service';
import { IPairAnagraphicUserRole } from '../../../models/request-and-responses/rest-api/interfaces/pairAnagraphicUsersRoles';
import { PataviumRole } from '../../../models/request-and-responses/rest-api/enums/role.enum.model';
import { catchError, finalize, first, map, take, tap } from 'rxjs/operators';

@Component({
    selector: 'app-customer',
    templateUrl: './customer.component.html',
    styleUrls: ['./customer.component.css']
})
export class CustomerComponent extends WithSearchBarAndSieve implements OnInit {
    customers: IShadowGenericAnagraphic[];
    //variables
    customer: IShadowCustomerCreate;
    linkedCustomers: IPairAnagraphicUserRole[] = [];
    isInLoad = false;
    progressLink: number = null;
    checkAll = false;
    modalRef: NgbModalRef;
    modalMode: ModalMode;
    isLoadingCity = false;
    customerCity: ICity;
    cityList: ICity[];
    isInitFinished = true;
    SieveSort = SieveSort;
    private customerSubscription: Subscription;
    customerFilter = SieveFilter.Customer.Customer;
    private sessionInfo: UserSessionInfo;
    SessionStorageService = SessionStorageService;

    public isPortaUnAmicoActivated = false;
    public portaUnAmicoResponse = {
        hash: null,
        taxCode: null,
        clientId: null,
        phoneNumber: null,
        email: null
    };
    public portaUnAmicoPhone;
    public loadingPortaUnAmico = false;

    constructor(
        private toastr: ToastrService,
        private dataService: DataService,
        private modalService: NgbModal,
        protected ptautocomplete: AutocompleteService,
        protected ngxService: NgxUiLoaderService,
        protected localStorage: LocalStorageService
    ) {
        super([], [], ptautocomplete, ngxService, localStorage);
        this.localStorageKey = LocalStorageKey.CustomerPageConfig;
        this.loadConfiguration();
        this.customerSubscription = new Subscription();
        this.sessionInfo = SessionStorageService.sessionInfo;
    }

    ngOnInit() {
        super.ngOnInit();
        this.initData();
    }

    initData() {
        this.isInitFinished = false;
        //customers
        const customerString = new SieveString(this.sieveConf);
        this.dataService.getCustomers(customerString).subscribe(customers => {
            this.rows = customers.total;
            this.customers = customers.payload;
            this.isInitFinished = true;
        });
    }

    private _setvariableBeforeOpeningModal(customer?: IShadowGenericAnagraphic) {
        //customer
        if (customer != null) {
            this.customer = new ShadowCustomerCreate(customer);
        } else {
            this.customer = new ShadowGenericAnagraphic(new ShadowGenericAnagraphic());
        }
        console.log(`RESPONSE customer=`, customer);
        console.log(`REQUEST customer =`, this.customer);
        // city
        this.customerCity = this._newCityOrNull(
            this.customer.istatCodeCity,
            this.customer.city,
            this.customer.shortProvince
        );

        if (this.modalMode === ModalMode.Link) {
            this.getLinkedCustomers(this.customer.id);
        }
    }

    private _openModal(templateRef: any) {
        if (templateRef == null) {
            console.log('OPEN MODAL: NULL ARGUMENT');
        } else {
            this.modalRef = this.modalService.open(templateRef, {
                centered: true,
                size: 'lg',
                windowClass: 'modal-xxl',
                backdrop: 'static',
                keyboard: false
            });
        }
    }

    private _setVariablesAndOpenModal(
        templateRef: any,
        customer: IShadowGenericAnagraphic,
        modalMode: ModalMode
    ) {
        this.modalMode = modalMode;
        this._setvariableBeforeOpeningModal(customer);
        this._openModal(templateRef);
    }

    infoCustomer(templateRef: any, customer: IShadowGenericAnagraphic) {
        this._setVariablesAndOpenModal(templateRef, customer, ModalMode.Info);
    }

    async setPortaUnAmico(templateRef: any, customer: IShadowGenericAnagraphic) {

        try {

            this.loadingPortaUnAmico = await true;
            await this.checkPortaUnAmico(customer.id);
            await this._setVariablesAndOpenModal(templateRef, customer, ModalMode.PortaUnAmico);

        } catch(err) {}

    }

    editCustomer(templateRef: any, customer: IShadowGenericAnagraphic) {
        this._setVariablesAndOpenModal(templateRef, customer, ModalMode.Edit);
    }

    createCustomer(templateRef: any) {
        this._setVariablesAndOpenModal(templateRef, null, ModalMode.Create);
    }

    removeCustomer(templateRef: any, customer: IShadowGenericAnagraphic) {
        this._setVariablesAndOpenModal(templateRef, customer, ModalMode.Remove);
    }

    unlinkCustomer(templateRef: any, customer: IShadowGenericAnagraphic) {
        this._setVariablesAndOpenModal(templateRef, customer, ModalMode.Link);
    }

    private _clearVariablesAfterClosingModal() {
        this.customer = null;
        this.modalRef = null;
        this.modalMode = null;
        this.isLoadingCity = false;
        this.customerCity = null;
        this.cityList = null;
        this.linkedCustomers = null;
        this.checkAll = false;
        this.progressLink = null;
        this.isInLoad = false;
    }

    closeModal() {
        this.modalService.dismissAll();
        this._clearVariablesAfterClosingModal();
    }

    saveThisCustomer() {
        this.dataService.createOrUpdateCustomer(this.customer).subscribe(response => {
            this.toastr.success(`Cliente ${this.customer.id} salvato con successo`, 'Successo');
            this.closeModal();
            this.initData();
        });
    }

    removeThisCustomer() {
        this.dataService.removeCustomer(this.customer.id).subscribe(response => {
            this.toastr.success(`Cliente ${this.customer.id} rimosso con successo`, 'Successo');
            this.closeModal();
            this.initData();
        });
    }

    //AUTOCOMPLETE
    //city
    fooSearch(term: string, item: any) {
        return true;
    }
    async lookForCustomerCities(userInput: string) {
        this.isLoadingCity = true;
        await new Promise<ICity[]>(executor =>
            this.dataService.getLikeNameCity(userInput).subscribe(response => {
                this.cityList = response.payload;
                executor(response.payload);
            })
        );
        this.isLoadingCity = false;
    }
    setCustomerCity(city: ICity) {
        this.customerCity = city;
        this.customer.istatCodeCity = city.codIstatCity;
        this.customer.city = city.name;
        this.customer.province = city.province;
        this.customer.shortProvince = city.shortProvince;
        console.log(`customer = `, this.customer);
    }

    // TABLE LABELS
    anagraphicTypeTableLabel(customer: IShadowCustomerCreate): string {
        switch (customer.anagraphicType) {
            case AnagraphicType.Person:
                return 'PRIVATO';
            case AnagraphicType.Company:
                return 'AZIENDA';
            case AnagraphicType.IndividualCompany:
                return 'AZIENDA INDIVIDUALE';
            case AnagraphicType.AssociazioneOrCondominio:
                return 'ASSOCIAZIONE/CONDOMINIO';
            default:
                return '--';
        }
    }
    fullNameTableLabel(customer: IShadowCustomerCreate): string {
        let label = '';
        if (customer.firstName != null) {
            label = customer.firstName;
        }
        if (customer.lastName != null) {
            if (customer.firstName != null) {
                label += ' ';
            }
            label += customer.lastName;
        }
        if (label.length === 0) {
            label = '--';
        }
        return label;
    }

    //MODAL LABELS
    get modalTitle() {
        switch (this.modalMode) {
            case ModalMode.Info:
                return 'Informazioni cliente';
            case ModalMode.Edit:
                return 'Modifica cliente';
            case ModalMode.Create:
                return 'Nuovo cliente';
            case ModalMode.Remove:
                return 'Rimuovi cliente';
            case ModalMode.Link:
                return 'Associazione cliente';
            default:
                console.error(`Not handled modalMode ${this.modalMode}`);
                return 'Cliente';
        }
    }

    //GENERAL
    private _isPrivateType(customer: IShadowCustomerCreate) {
        return customer.anagraphicType === AnagraphicType.Person;
    }
    private _isBusinessType(customer: IShadowCustomerCreate) {
        return (
            customer.anagraphicType === AnagraphicType.Company ||
            customer.anagraphicType === AnagraphicType.IndividualCompany
        );
    }
    private _isAssociazioneOrCondominio(customer: IShadowCustomerCreate) {
        return customer.anagraphicType === AnagraphicType.AssociazioneOrCondominio;
    }
    private _typeIsDefined(customer: IShadowCustomerCreate) {
        return customer.anagraphicType != null;
    }
    private _newCityOrNull(istatCode: string, city: string, shortProvince: string) {
        const isValid = (str: string) => {
            return str != null && str.length > 0;
        };
        let _city: ICity = null;
        if (isValid(istatCode) && isValid(city) && isValid(shortProvince)) {
            const c: ICityResponse = {
                codIstatCity: istatCode,
                name: city,
                shortProvince: shortProvince,
                province: null,
                idProvince: null,
                postalCode: null
            };
            _city = new City(c);
        }
        console.log(`city =`, _city);
        return _city;
    }
    private _isIndividualCompany(customer: IShadowCustomerCreate) {
        return this.customer.anagraphicType === AnagraphicType.IndividualCompany;
    }

    //MODAL
    //modalMode
    get isInfoMode() {
        return this.modalMode === ModalMode.Info;
    }

    //checks
    get typeIsDefined() {
        return this._typeIsDefined(this.customer);
    }
    get isPrivateType() {
        return this._isPrivateType(this.customer);
    }
    get isBusinessType() {
        return this._isBusinessType(this.customer);
    }
    get isAssociazioneOrCondominio() {
        return this._isAssociazioneOrCondominio(this.customer);
    }
    get isIndividualCompany() {
        return this._isIndividualCompany(this.customer);
    }
    get iAmAdmin(): boolean {
        return this.sessionInfo.iAmAdmin;
    }
    //setters
    setPrivateType() {
        this.customer = new ShadowCustomerCreate(new ShadowCustomerCreate());
        this.customer.anagraphicType = AnagraphicType.Person;
    }
    setBusinessType() {
        this.customer = new ShadowCustomerCreate(new ShadowCustomerCreate());
        this.customer.anagraphicType = AnagraphicType.Company;
    }
    setAssociazioneOrCondominio() {
        this.customer = new ShadowCustomerCreate(new ShadowCustomerCreate());
        this.customer.anagraphicType = AnagraphicType.Company;
    }
    toggleCompanyType() {
        const anagraphicType = this.customer.anagraphicType;
        //if it's not a company exit
        if (
            anagraphicType !== AnagraphicType.Company &&
            anagraphicType !== AnagraphicType.IndividualCompany
        ) {
            return;
        }
        //if it'a company, change anagraphicType
        let newAnagraphicType = AnagraphicType.Company; //default
        if (anagraphicType === AnagraphicType.Company) {
            newAnagraphicType = AnagraphicType.IndividualCompany;
        }
        this.customer.anagraphicType = newAnagraphicType;
    }

    // get linked customers
    async getLinkedCustomers(customerId) {
        await new Promise<IPairAnagraphicUserRole[]>(executor =>
            this.dataService.getLinkedCustomers(customerId).subscribe(response => {
                this.linkedCustomers = response.payload;
                executor(response.payload);
            })
        );
    }

    // unlink customer
    toggleCheckAll() {

        if (this.checkAll === false) {

            this.linkedCustomers.map(customer => {
                customer.status = false;
            });

        } else {

            this.linkedCustomers.map(customer => {
                customer.status = true;
            });

        }
    }



    async confirmUnlink() {

        try {

            const toUnlink = this.linkedCustomers.filter((customer) => {
                return customer.status === true;
            });

            if (toUnlink.length === 0) {

                this.toastr.warning("E' necessario selezionare almeno un elemento da dissociare", "Attenzione");
                return;
            }

            let doneCall = 0;
            const totalCall = toUnlink.length * 2;
            this.isInLoad = true;

            for (let i = 0; i < toUnlink.length; i++) {

                try {
                    await this.dataService
                        .unlinkCustomer(toUnlink[i].idClient, toUnlink[i].idUser)
                        .pipe(take(1))
                        .toPromise();
                    doneCall++;
                    this.progressLink = Math.ceil((doneCall / totalCall) * 100);
                } catch {
                    this.progressLink = null;
                    this.isInLoad = false;
                    return;
                }

            }
            await this.initData();
            await this.toastr.success('Clienti dissociati correttamente', 'Successo', {
                closeButton: true
            });
            await this.closeModal();

        } catch (e) {

            this.toastr.error("Errore durante l\'operazione", "Errore");

        }

    }


    async checkPortaUnAmico(id) {

        try {

            this.dataService.checkByTaxCode(id).subscribe(response => {

                if (response.status === 404) { // non è mai stato abilitato lo abilito e mostro i dati di invto

                    this.isPortaUnAmicoActivated = false;
                    this.loadingPortaUnAmico = false;

                } else { // mostro solo la possibilità di reinvite con email e telefono

                    this.isPortaUnAmicoActivated = true;
                    this.portaUnAmicoResponse = {
                        hash: response.hash,
                        taxCode: response.taxCode,
                        clientId: response.clientId,
                        email: response.email,
                        phoneNumber: response.phone
                    }
                    this.loadingPortaUnAmico = false;

                }

            });

        } catch (e) {
            this.loadingPortaUnAmico = false;

            this.toastr.error("Errore durante l\'operazione", "Errore");

        }

    }

    async activatePortaUnAmico(id) {

        try {

            this.dataService.addPortaUnAmico(id, this.sessionInfo.userId).subscribe(response => {

                if (response && response.status === 200 || response.status === 201) {

                    this.toastr.success(`Porta Un Amico ${this.customer.id} attivato con successo`, 'Successo');
                    this.isPortaUnAmicoActivated = true;
                    this.portaUnAmicoResponse = {
                        hash: response.hash,
                        taxCode: response.taxCode,
                        clientId: response.clientId,
                        email: response.email,
                        phoneNumber: response.phone
                    }
                    this.loadingPortaUnAmico = false;
                    // this.closeModal();
                    // this.initData();

                } else {

                    this.loadingPortaUnAmico = false;
                    this.toastr.error(`Non è possibile attivare Porta Un Amico per il cliente ${this.customer.id}`, 'Errore');

                }
            
            });

        } catch (e) {
            this.loadingPortaUnAmico = false;

            this.toastr.error("Errore durante l\'operazione", "Errore");

        }

    }

    async sendInvitePortaUnAmico() {

        try {

            this.dataService.invitePortaUnAmico({
                clientId: this.portaUnAmicoResponse.clientId,
                hash: this.portaUnAmicoResponse.hash,
                taxCode: this.portaUnAmicoResponse.taxCode,
                email: this.portaUnAmicoResponse.email,
                phoneNumber: this.portaUnAmicoResponse.phoneNumber
            }).subscribe(response => {

                if (response && (response.status === 200 || response.status === 201) && (response.email === true || response.phone === true)) {

                    this.toastr.success(`Invito inviato con successo`, 'Successo');
                    this.closeModal();
                    this.initData();

                } else {

                    this.toastr.error(`Non è stato possibile inviare l'invito`, 'Errore');

                }
            
            });

        } catch (e) {

            this.toastr.error("Errore durante l\'operazione", "Errore");

        }

    }

}



// WEBPACK FOOTER //
// ./src/app/pages/common/customer/customer.component.ts